import { catalogProductsContext } from 'pages/addProducts/CatalogProductsResolver';
import { exclusiveProductsContext } from 'pages/addProducts/ExclusiveProductsResolver';
import { privateProductsContext } from 'pages/addProducts/PrivateProductsResolver';
import { AccountNumberParams, managePricingContext } from 'pages/managePricing/managePricingResolver';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ModelCurrentPrices, TAddProductsData } from 'types/backend';
import useSubmitNew from './useSubmitNew';
import { formatLocalDateToLocalISODateTimeString } from 'shared/utility';

export function useCreateProductRequest() {
    const params = useParams<AccountNumberParams>();

    const mapper = (products: TAddProductsData[]): ModelCurrentPrices[] =>
        products.map((product) => {
            const status = 'Approved';
            const approver = 'Not Required';

            const requestItem: ModelCurrentPrices = {
                currentpriceid: 0,
                recid: '0',
                accountnumber: params.accountNumber,
                enduseraccountnumber: '',
                pricetype: 'Market Price',
                itemorgroup: product.itemid.toString(),
                productGroup: product.productcategoryname,
                startdate: formatLocalDateToLocalISODateTimeString(new Date().toLocaleDateString()),
                enddate: '2199-12-31T00:00:00.000Z',
                price: product.price,
                targetPrice: product.targetprice,
                status,
                approver,
                estmonthlyrevenue: '',
                competitor: '',
                competitorprice: '',
                source: '',
                modifiedby: '',
                effectivestart: new Date().toISOString(),
                lastupdated: undefined,
                effectiveend: undefined,
                deleted: false,
            };
            return requestItem;
        });

    const addcatalogProductsContext = useContext(catalogProductsContext);
    const addexclusiveProductsContext = useContext(exclusiveProductsContext);
    const addprivateProductsContext = useContext(privateProductsContext);

    const onSuccess = async (form: TAddProductsData[]) => {
        if (addcatalogProductsContext?.refreshData) {
            addcatalogProductsContext.refreshData();
        }
        if (addexclusiveProductsContext?.refreshData) {
            addexclusiveProductsContext.refreshData();
        }
        if (addprivateProductsContext?.refreshData) {
            addprivateProductsContext.refreshData();
        }
    };

    const submitRequest = useSubmitNew({
        mapper,
        name: 'marketprice',
        context: managePricingContext,
        onSuccess,
    });

    return submitRequest;
}
